import southAfricaFlag from "../../assets/images/forex/south-africa.svg";

export const DPOS_FIGMA_ASSETS = {
  backNav: "/dpos/figma/icons/back-nav.svg",
  closeDelete: "/dpos/figma/icons/close-delete.svg",
  cryptoBtc: "/dpos/figma/icons/crypto-btc.svg",
  cryptoEth: "/dpos/figma/icons/crypto-eth.svg",
  dposErrorCircle: "/dpos/figma/graphics/dpos-error-circle.svg",
  dposErrorDelete: "/dpos/figma/graphics/dpos-error-delete.svg",
  dposErrorHand: "/dpos/figma/graphics/dpos-error-hand.svg",
  dposSuccessCard: "/dpos/figma/graphics/dpos-success-card.svg",
  dposSuccessDot: "/dpos/figma/graphics/dpos-success-dot.svg",
  dposSuccessStar: "/dpos/figma/graphics/dpos-success-star.svg",
  loadingLogo: "/dpos/figma/graphics/loading-logo.svg",
  paylinkCopy: "/dpos/figma/icons/paylink-copy.svg",
  paylinkShare: "/dpos/figma/icons/paylink-share.svg",
  passwordAsterisk: "/dpos/figma/graphics/cashier-password-asterisk-17544.svg",
  passwordDot: "/dpos/figma/graphics/cashier-password-dot-17544.svg",
  securedLock: "/dpos/figma/icons/secured-lock.svg",
  securedLogo: "/dpos/figma/icons/secured-logo.svg",
  southAfricaFlag,
  transferVertical: "/dpos/figma/icons/transfer-vertical.svg",
  cashierHomeDot: "/dpos/figma/graphics/cashier-home-dot-17613.svg",
  cashierHomeFinance: "/dpos/figma/graphics/cashier-home-finance-17613.svg",
  cashierHomeStar: "/dpos/figma/graphics/cashier-home-star-17613.svg",
  cashierEntryDot: "/dpos/figma/graphics/cashier-entry-dot.svg",
  cashierEntryFinance: "/dpos/figma/graphics/cashier-entry-finance.svg",
  cashierEntryStar: "/dpos/figma/graphics/cashier-entry-star.svg",
  search: "/dpos/figma/icons/search.svg",
  needHelpSystem: "/dpos/figma/icons/need-help-system.svg",
} as const;
